import React, { useEffect, useState } from 'react';
import useDebounce from '../../../hooks/useDebounce';
import useUpdateEffect from '../../../hooks/useUpdateEffect';

const QuantityInput = ({ value, className, onChange, disabled }) => {
	const [currentValue, setCurrentValue] = useState(() => (value === null || value === undefined ? '' : value.toString()));
	const debouncedValue = useDebounce(currentValue);

	useEffect(() => {
		setCurrentValue(value === null || value === undefined ? '' : value.toString());
	}, [value]);

	useUpdateEffect(() => {
		(value || 0).toString() !== debouncedValue && onChange(debouncedValue);
	}, [debouncedValue]);

	const handleRequestedQuantityChange = (changeBy, event) => {
		const value = +event.target.value;
		if(changeBy==0 && event.target.value===''){
			setCurrentValue('');
			return;
		}else{
			setCurrentValue(currentValue => Math.min(Math.max(changeBy ? +currentValue + changeBy : value, 1), 999999999).toString());
		}
	};

	return (
		<p className="quantityInput" style={{ position: 'relative', margin: '0' }}>
			<button type="button" disabled={disabled} onClick={handleRequestedQuantityChange.bind(this, -1)}>
				-
			</button>
			<input
				id="qty"
				type="number"
				className={`fullWidth text-center${className ? ` ${className}` : ''}`}
				min={0}
				value={currentValue}
				onChange={handleRequestedQuantityChange.bind(this, 0)}
				disabled={disabled}
			/>
			<button type="button" disabled={disabled} onClick={handleRequestedQuantityChange.bind(this, 1)}>
				+
			</button>
		</p>
	);
};

export default QuantityInput;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/common/quantityInput.jsx